module.exports = __webpack_public_path__ + "images/my-account-e5193d0cf20ae246f2c2721f7be195db.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/my-account.png
// module id = ./client/assets/images/my-account.png
// module chunks = 90